






















Currency = require 'models/currency.coffee'

module.exports =
  name: 'bottom_menu'
  components: `{
    currencies_calculator: () => import(/* webpackChunkName: "currencies_calculator" */'./currencies_calculator.vue'),
    categories_editor: () => import(/* webpackChunkName: "categories_editor" */'./categories_editor.vue'),
    shortcuts_table: () => import(/* webpackChunkName: "shortcuts" */'promo/shortcuts.vue')
  }`
  data: ->
    exchange_rates_modal:    false
    shortcuts_modal:         false
    categories_editor_modal: false
  methods:
    openExchangeRatesModal: ->
      @$store.dispatch('hideTransactionsPopovers')
      @exchange_rates_modal = true
      HM.track 'view-exchange_rates_modal'
    closeExchangeRatesModal: ->
      @exchange_rates_modal = false
    openShortcutsModal: ->
      @$store.dispatch('hideTransactionsPopovers')
      @shortcuts_modal = true
      HM.track 'view-shortcuts_modal'
    openCategoriesEditorModal: ->
      @$store.dispatch('hideTransactionsPopovers')
      @categories_editor_modal = true
      HM.track 'view-categories_editor_modal'
    closeCategoriesEditorModal: ->
      @$store.dispatch('hideTransactionsPopovers')
      @categories_editor_modal = false
